import { render, staticRenderFns } from "./AddCostFlatModal.vue?vue&type=template&id=74bd5d7c&"
import script from "./AddCostFlatModal.vue?vue&type=script&lang=js&"
export * from "./AddCostFlatModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports